import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref, watch } from 'vue';
import { TranslateResult } from 'vue-i18n';


/** @deprecated THIS COMPONENT IS FROZEN **/
const __default__ = {};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'TagInput',
  props: {
    value: { default: () => [] },
    tags: null,
    loading: { type: Boolean, default: false },
    id: null,
    placeholder: null,
    appendToBody: { type: Boolean, default: false },
    allowNew: { type: Boolean, default: false }
  },
  emits: ["input", "blur"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'input', value: string): void;
  (e: 'blur'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { value: string[] | null | undefined, tags: string[], loading: boolean, id?: string, placeholder?: string | TranslateResult, appendToBody: boolean, allowNew: boolean };





const valueInternal =  ref<string[]>([]);
const remainingTags = ref<string[]>([]);
const filteredTags = ref<string[]>([]);

onMounted(() => {
  valueInternal.value = props.value ?? [];
  remainingTags.value = excludeSelectedTags(props.tags);
  filteredTags.value = excludeSelectedTags(props.tags);
});

watch(
  () => props.tags,
  () => {
    filteredTags.value = remainingTags.value = props.tags;
  },
);

function excludeSelectedTags(tags: string[]) {
  return tags.filter((tag) => !valueInternal.value.includes(tag));
}

function onSelectedTagsChanged(selectedTags: string[]) {
  remainingTags.value = filteredTags.value = excludeSelectedTags(props.tags);
  valueInternal.value = selectedTags;
  emit('input', selectedTags);
}

function updateFilteredTags(filter: string): void {
  filteredTags.value = remainingTags.value.filter((tag) =>
    tag.toLowerCase().includes(filter.trim().toLowerCase()),
  );
}

return { __sfc: true,props, emit, valueInternal, remainingTags, filteredTags, excludeSelectedTags, onSelectedTagsChanged, updateFilteredTags }
}

})